import { useEffect } from 'react';

type StoreSeoHeadProps = {
  seoSchema: unknown;
};

export function StoreSeoHead({ seoSchema }: StoreSeoHeadProps) {
  useEffect(() => {
    if (seoSchema == null) return;

    let script = document.querySelector('script[data-store-schema="true"]');
    if (!script) {
      script = document.createElement('script');
      script.setAttribute('type', 'application/ld+json');
      script.setAttribute('data-store-schema', 'true');
      document.head.appendChild(script);
    }

    script.textContent =
      typeof seoSchema === 'string' ? seoSchema : JSON.stringify(seoSchema);
  }, [seoSchema]);

  return null;
}
